import axios from 'axios';
import config from 'config';
import { ContentEvent } from './types';

export const fistbumpApi = {
  /**
   * Records post impressions and opens. Max 50 events per call; returns 204. Posts the user can't read, or wrote or
   * can post for, are ignored. Sent over fetch with `keepalive`, so a flush when the page is hidden still arrives.
   */
  trackContent: (events: ContentEvent[]) =>
    axios.post<void>(
      `${config.COMPANIES_API_URL}/fistbump/content`,
      { events },
      {
        adapter: 'fetch',
        fetchOptions: { keepalive: true },
        headers: { 'Content-Type': 'application/json', ['X-API-Id']: 'portal' },
      },
    ),
};
